import React from "react";
import { useArbeitszeitStore } from "../../../store/zustandArbeitszeitenStore";
import IWInformationModal from "../../uiElemente/IWInformationModal/IWInformationModal";

function InformationModalWrapper() {
  const isModalInformationVisible = useArbeitszeitStore(state => state.isModalInformationVisible);
  const setIsModalInformationVisible = useArbeitszeitStore(state => state.setIsModalInformationVisible);

  return (
    <IWInformationModal
      displayModal={isModalInformationVisible}
      closeAction={setIsModalInformationVisible}
    />
  );
}

export default React.memo(InformationModalWrapper);